import React from "react";
import Message from "./Message";
import FlipMove from "react-flip-move";


const getCalenderFormatForTimeLine = (dateTime) => {
    return TB.moment(dateTime).utc(dateTime).local().calendar(null, {
        sameDay: '[Today]',
        lastDay: '[Yesterday]',
        lastWeek: 'dddd, MMM Do',
        sameElse: () => {
            if (TB.moment().year() === TB.moment(dateTime).year()) {
                return 'dddd, MMM Do';
            } else {
                return 'dddd, MMM Do YYYY';
            }
        },
    });
};
const MessageList = ({messages, auth, ...props}) => {

    return (
        <FlipMove typeName={null} maintainContainerHeight={false}>
            {messages.map((message, index) => {
                let elements = [
                    <Message key={"message-" + message.id} auth={auth} message={message}/>
                ];
                if (index === 0 || !TB.moment(message.sent_at).isSame(messages[index - 1]?.sent_at, 'day')) {
                    let prevMessage = index === 0 ? message : messages[index - 1];

                    if (prevMessage?.sent_at) {
                        elements.unshift((
                            <div className="chat__msg-day-divider flex justify-center"
                                 key={prevMessage.sent_at}>
                                <span className="chat__msg-day-title">
                                    {getCalenderFormatForTimeLine(prevMessage.sent_at)}
                                </span>
                            </div>
                        ))
                    }
                }
                return <React.Fragment key={"message-box-" + message.id}>
                    {elements}
                </React.Fragment>
            })}
        </FlipMove>
    )
}

export default MessageList;